import React, { Fragment, useEffect, useState } from "react";
import { getPayResult } from "./Components/Services";
import { Helmet } from "react-helmet";
import Loading from "../../Common/Loading";
import Result from "./Components/Result";

const Index = ({isApp}) => {
  const peykey = window.location.href.split("peykey=")[1];
  const initialState = {
    loading: true,
    data: null,
    model_order: null,
    score: null,
    app: "false",
    paykey: "undefined",
  };
  const [state, setState] = useState(initialState);
  useEffect(() => {
    if (peykey) {
      Handler(peykey);
    }
  }, []);
  const Handler = data => {
    setState({ ...state, loading: true });
    getPayResult(data).then(result => {
      setState({
        loading: false,
        data: result.pament,
        model_order: result.model_order,
        score: result.score,
        app: result.app,
        paykey: result.paykey,
      });
    });
  };

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | نتیجه پرداخت</title>
      </Helmet>
      <section className="pay-result">
        {state.loading ? (
          <Loading count={1} col={12} height={"90vh"} />
        ) : (
          <Result isApp={isApp} data={state} />
        )}
      </section>
    </Fragment>
  );
};

export default Index;
